/**
 * 三包理赔的新增页面 货品配置处理
 * @author zjs
 * @time 2017-09-18
 */
export default {
    data () {
        return {
            productConfig: [{
                prop: 'product',
                label: '货品编码',
                width: 110,
                json: {
                    size: 'small',
                    api: 'manage/product',
                    prop: 'product_cai'
                },
                component: 'LyAutoProduct'
            }, {
                prop: 'product',
                label: '货品名称',
                width: 286,
                json: {
                    size: 'small',
                    prop: 'product_name'
                },
                component: 'LyAutoProduct'
            }, {
                prop: 'taihao',
                label: '胎号/DOT号',
                width: 140,
                json: {
                    width: '856px',
                    api: 'api/taihaolist',
                    size: 'small',
                    prop: 'taihao_no',
                    fields: [{
                        "label":"货品编码",
                        "prop":"product_cai",
                        width: 100
                    },{
                        "label":"货品名称",
                        "prop":"product_name",
                        width: 285
                    },{
                        "label":"胎号",
                        "prop":"taihao_no",
                        width: 140
                    },{
                        "label":"销售时间",
                        "prop":"xiaoshou_time",
                        width: 90
                    },{
                        "label":"销售客户名称",
                        "prop":"xiaoshou_customer",
                        width: 240
                    }]
                },
                component: 'LyAutoSearch'
            }, {
                prop: 'jiandingren',
                label: '鉴定人',
                width: 80,
                component: 'ElInput'
            }, {
                prop: 'self_number',
                label: '自编号',
                width: 80,
                component: 'ElInput'
            }, {
                prop: 'symptom',
                label: '病象(理赔原因)',
                width: 110,
                json: {
                    api: 'api/bingxiang',
                    width: '400px',
                    size: 'small',
                    prop: 'bingxiang_name',
                    fields: [{
                        label: '病象',
                        prop: 'bingxiang_name'
                    },{
                        label: '病象分类',
                        prop: 'bingxiang_type'
                    }]
                },
                component: 'LyAutoSearch'
            }, {
                prop: 'lipei_type',
                label: '理赔类型',
                width: 140,
                json: {
                    all: false,
                    data: [{
                        value: '正常理赔',
                        label: '正常理赔'
                    }, {
                        value: '照顾理赔',
                        label: '照顾理赔'
                    }, {
                        value: '商务理赔',
                        label: '商务理赔'
                    }, {
                        value: '废胎处理',
                        label: '废胎处理'
                    }, {
                        value: '商务理赔(未收)',
                        label: '商务理赔(未收)'
                    }]
                },
                component: 'LySelect'
            }, {
                prop: 'tiesun_amount',
                label: ' 贴损金额',
                width: 80,
                component: 'LyInputNumber'
            }, {
                prop: 'lipei_amount',
                label: ' 理赔金额',
                width: 80,
                component: 'LyInputNumber'
            }, {
                prop: 'tiesun_type',
                label: '贴损类型',
                width: 85,
                json: {
                    all: false,
                    data: [{
                        value: '一套',
                        label: '一套'
                    }, {
                        value: '一条',
                        label: '一条'
                    }]
                },
                component: 'LySelect'
            }, {
                prop: 'yuhua',
                label: '余花',
                width: 100,
                component: 'ElInput'
            }, {
                prop: 'comment',
                label: '备注',
                width: 150,
                component: 'ElInput'
            }]
        }
    }
}